@if (authorized) {
<div class="app-header app-header-authorized" [ngClass]="{ 'app-header-authorized--no-envelope': !messagesEnabled }">
  <app-logo (logoClicked)="logoClicked()"></app-logo>
  <app-nav></app-nav>
  <app-user></app-user>
  @if (messagesEnabled) {
  <app-envelope></app-envelope>
  }
</div>
} @else {
<div class="app-header app-header-unauthorized">
  <app-logo (logoClicked)="logoClicked()"></app-logo>
  @if (multilingual$ | async) {
  <app-lang></app-lang>
  }
</div>
}
